import { useCallback, useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'
import { type ISOCountry } from 'cube/components/CountryCodeSelect'

import config from 'config'

export const useISOCountryData = () => {
  const { data: ISOCountryData = [] } = useQuery<ISOCountry[]>({
    queryKey: ['static-iso-country-data'],
    queryFn: () =>
      fetch(`${config.FE_STATIC_DATA}/api/ISOCountryData`).then((response) =>
        response.json()
      ),
    staleTime: 60000,
  })

  const countryOptions = useMemo(
    () =>
      ISOCountryData?.map((country) => ({
        label: country.name,
        value: country['alpha-2'],
        region: country.region,
      })) ?? [],
    [ISOCountryData]
  )

  const getCountryNameByCode = useCallback(
    (countryCode: string) =>
      ISOCountryData?.find((country) => country['alpha-2'] === countryCode)
        ?.name,
    [ISOCountryData]
  )

  return { countryOptions, getCountryNameByCode }
}
